import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayField'
})
export class DisplayFieldPipe implements PipeTransform {

  transform(value: Object, field: string): any {
    try {
      return value && value.hasOwnProperty(field)
      ? value[field]
      : undefined
    } catch (error) {
      console.error(error)
      return undefined
    }

  }

}
